// @flow

import React, { type Node } from 'react';
import { usePendingIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';
import { formatUberPixExpirationDatetime } from '@tectonics/prs/voucher';
import { getExpirationOrDueDatetime } from '@tectonics/prs/incoming-payment/get-expiration-or-due-datetime';

export function ExpirationDateTime(): Node {
  return (
    <>
      <DateTimeFormatted />
    </>
  );
}

function DateTimeFormatted(): Node | null {
  const incomingPayment = usePendingIncomingPayment();
  const country = getCountry(incomingPayment);
  const dateTobeFormatted = getExpirationOrDueDatetime(incomingPayment);
  const formattedDateToBeReturned : string | null = formatUberPixExpirationDatetime(dateTobeFormatted);

  switch (country) {
    case 'br':
      return  formattedDateToBeReturned;

    default:
      throw new Error(`Voucher Ticket Due Date Title - Not implemented for country "${country}" yet`);
  }
}
